module.exports = __webpack_public_path__ + "img/compact.20ca70c4.png";